module.exports = __webpack_public_path__ + "img/enablement-list1-4.0c45ca2c.png";